import { StyleSheet } from 'aphrodite';
import { aceGray, background, brandPrimary, charmGray, shuffleGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	saveButton: {
		width: 160,
	},
	modalButtons: {
		marginRight: 12,
	},
	modalFooter: {
		justifyContent: 'space-around',
	},
	container: {},
	header: {
		color: brandPrimary,
		fontSize: 18,
	},
	info: {
		color: charmGray,
		fontSize: 12,
		paddingBottom: 7,
	},
	'modal-overlay-content-header': {
		color: '#000000',
	},
	useSharedMailbox: {
		fontSize: 12,
		marginRight: 4,
	},
	useSharedMailboxLabel: {
		color: '#0D0F11',
	},
	labels: {
		color: charmGray,
		fontSize: 12,
		marginRight: 4,
		width: 100,
	},
	modalBody: {
		display: 'flex',
		flexDirection: 'column',
		width: 400,
	},
	inputRow: {
		alignItems: 'center',
		display: 'flex',
		flex: 2,
		flexDirection: 'row',
		margin: '12px 0',
		maxHeight: 35,
	},
	inputStacked: {
		display: 'flex',
		flex: 2,
		flexDirection: 'column',
		margin: '12px 0',
		maxHeight: 35,
		paddingBottom: 12,
	},
	loading: {
		marginTop: 8,
	},
	textBox: {
		background,
		border: `1px solid ${shuffleGray}`,
		borderRadius: 8,
		boxSizing: 'border-box',
		color: aceGray,
		// fontSize: 12,
		height: 36,
		marginRight: 8,
		padding: '12px 12px 12px 16px',
		flexGrow: 1,
	},
});
